import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';

import { ToastService } from 'admin/core/notifications/toast.service';
import { getError } from './models/error.model';

export const messageToastInterceptor: HttpInterceptorFn = (request, next) => {
  const toast = inject(ToastService);

  return next(request).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse) {
        const apiError = getError(error);
        const message = apiError?.message ?? Object.values(apiError?.errors ?? {}).flat()[0];

        if (message) {
          toast.show(message);
        }
      }

      return throwError(() => error);
    }),
  );
};
